import React, {useState} from "react";
import {Button, Card, Field, Input} from "@fluentui/react-components";
import {apiPost} from "../../../api/client";
import {useNavigate} from "react-router-dom";
import {CardWrapCentered} from "../../../styled/CardWrapCentered";
import {ArrowLeftRegular} from "@fluentui/react-icons";

export const AccommodationApartmentCreate: React.FC = () => {
    const [name, setName] = useState("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true)

        apiPost('apartments/create.php', {
            name: name
        }).then((response) => {
            console.log(response);
            navigate('/accommodation')
        }).catch((error) => {

        }).finally(() => {
            setLoading(false)
        });
    }

    return (
        <CardWrapCentered>
            <Card style={{width: '100%', maxWidth: '600px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <h1>Nový apartmán</h1>
                    <Button onClick={() => navigate('/accommodation')} icon={<ArrowLeftRegular/>}>Zpět</Button>
                </div>
                <form onSubmit={handleSubmit}>
                    <Field label={'Název'}>
                        <Input type={'text'} required value={name} onChange={(e) => setName(e.target.value)}
                               autoFocus={true}/>
                    </Field>
                    <div style={{height: '1rem'}}></div>
                    <Button type={'submit'} disabled={name?.length < 4 || loading}>
                        {loading ? 'Vytvářím...' : 'Vytvořit'}
                    </Button>
                </form>
            </Card>
        </CardWrapCentered>
    )
}